import React from 'react';

import { TableCell, TableRow } from '@mui/material';

import { ISummaryStatisticsItem } from '../../types/summary.type';

interface IProps {
  title: string;
  statistics: ISummaryStatisticsItem;
}

const SummaryStatistics = React.memo(({ title, statistics }: IProps) => (
  <>
    <TableRow>
      <TableCell>{title}</TableCell>
      <TableCell align="center">{statistics.accepted}</TableCell>
      <TableCell align="center">{statistics.refused}</TableCell>
      <TableCell align="center">{statistics.total}</TableCell>
    </TableRow>

    <TableRow>
      <TableCell />
      <TableCell align="center">{statistics.acceptedFraction}%</TableCell>
      <TableCell align="center">{statistics.refusedFraction}%</TableCell>
      <TableCell />
    </TableRow>
  </>
));

export default SummaryStatistics;
